import React, { useCallback, useState } from "react";
import { Navbar, Container, Nav, Dropdown, Button, Col } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router";
import { fetchAnnee } from "../../Redux/anneeReduce";
import { countListCommande } from "../../Redux/commandeReduce";
import { getNotification, updateNotif } from "../../Redux/notificationReduce";
import { verification } from "../../Redux/usersReduce";
import Select from "react-select";
import { useTranslation } from 'react-multi-lang'
import { IoCalendarClearOutline } from "react-icons/io5";
import { RxAvatar } from "react-icons/rx";
import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';

function Header({ users, client }) {

  const [isFrench, setIsFrench] = useState(
    localStorage.getItem("lang") === "fr"
  );

  const handleLanguageToggle = () => {
    const newLang = isFrench ? "en" : "fr";
    localStorage.setItem("lang", newLang);
    window.location.reload();
  };

  const dispatch = useDispatch();
  const t = useTranslation();
  const [notification, setNotification] = React.useState([]);
  let lang = window.localStorage.getItem("lang");
  var date = new Date().getFullYear();
  var anneeLocal = localStorage.getItem("annee");
  if (anneeLocal === null) {
    localStorage.setItem("annee", date);
    anneeLocal = localStorage.getItem("annee");
  }
  const [annee, setAnnee] = React.useState();
  const [image, setImage] = React.useState(null);
  const [nb, setNb] = React.useState(0);
  const [optionsAnnee, setOptionsAnnee] = React.useState([
    {
      value: "",
      label: "Annee",
      isDisabled: true,
    },
  ]);
  let nom = users.user.nom_prenom;
  function LogOut(e) {
    e.preventDefault();
    localStorage.clear();
    window.location.replace("/login");
  }
  const mobileSidebarToggle = (e) => {
    e.preventDefault();
    document.documentElement.classList.toggle("nav-open");
    var node = document.createElement("div");
    node.id = "bodyClick";
    node.onclick = function () {
      this.parentElement.removeChild(this);
      document.documentElement.classList.toggle("nav-open");
    };
    document.body.appendChild(node);
  };

  const changeEtat = useCallback(async (element) => {
    var updateNote = await dispatch(updateNotif({
      id: element ? element.id : 0,
      idUser: element ? element.id_user : -1
    }))
    if (updateNote) {
      if (element == undefined) getNotif();
      else window.location.replace(element.url);
    }

  }, [dispatch]);


  const [data, setData] = useState([]);
  const fectchListCommande = useCallback(
    async (idUser,client) => {
      var etat = users.user.id_role == 5 ? [1] : [0, 1];
      var list = await dispatch(
        countListCommande({
          id_user: idUser,
          etat,
          annee: anneeLocal,client
        })
      );
      var res = list.payload;

      setData(res.countcmd);
    },
    [dispatch]
  );


  const getNotif = useCallback(async (anneeLocal,client) => {
    var res = await dispatch(getNotification({ annee: anneeLocal,client }));
    var notif = res.payload;
    var array = [];
    array.push(
      <Dropdown.Item
        className="enteteDropDown"
        href="#"
        key={"entet" + notif.length}
      >
        {notif.length} {t('notification')}
      </Dropdown.Item>
    );
    var arrayDiv = [];
    notif.forEach(element => {
      arrayDiv.push(
        <Dropdown.Item
          className={element.lu === 0 ? "nonlu" : ""}
          href="#"
          key={"notif" + element.id}
          onClick={() => { changeEtat(element) }}
        >
          {lang == "fr" ? element.sujet : element.sujet_en}
        </Dropdown.Item>
      );
    });
    array.push(<div key="onScroll" className={arrayDiv.length > 6 ? "onScroll" : ""}>{arrayDiv}</div>)
    if (notif.length === 0) {
      array.push(
        <Dropdown.Item
          href="#"
          key={0}
        >
          {t('aucune_notification')}
        </Dropdown.Item>
      );
    }
    array.push(
      <Dropdown.Item
        className="footerDropDown"
        href="#"
        key={"footer" + array.length}
        onClick={(event) => {
          changeEtat()
        }}
      >
        {t('lire_notification')}
      </Dropdown.Item>
    );
    setNb(notif.length);
    setNotification(array);
  }, [dispatch, changeEtat]);



  const customDropdownIndicator = () => (
    <div >
      <IoCalendarClearOutline />
    </div>
  );

  const getAnnes = React.useCallback(async () => {
    var year = await dispatch(fetchAnnee());
    var arrayOption = [];
    var selected = null;
    var yearNow = new Date().getFullYear();
    year.payload.forEach((element) => {
      arrayOption.push({
        value: element.annee,
        label: element.annee,
        selected: element.selected,
        id: element.id,
      });
      if (yearNow === element.annee)
        selected = {
          value: element.annee,
          label: element.annee,
          selected: element.selected,
          id: element.id,
        };
    });
    var annee = localStorage.getItem("annee");
    if (annee === null) {
      setAnnee({ value: selected.value, label: selected.value });
      localStorage.setItem("annee", selected.value);
    } else {
      setAnnee({ value: annee, label: annee });
      localStorage.setItem("annee", annee);
    }

    setOptionsAnnee(arrayOption);
  }, [dispatch]);

  const verifToken = useCallback(async () => {
    try {
      dispatch(verification()).then(e => {
        if (e.payload === false) {
          localStorage.clear();
          window.location.replace("/login");
        } else {
          setImage(e.payload.image)
        }
      })
    } catch (error) {

    }

  }, [dispatch]);


  React.useEffect(() => {
    verifToken()
    getAnnes();
    getNotif(anneeLocal,client);
    if(users.user.id_role == 5) fectchListCommande(users.id,client)
  }, [getAnnes, getNotif, image, anneeLocal]);

  function updateAnnee(value) {
    localStorage.setItem("annee", value.value);
    window.location.reload();
  }

  return (
    <Navbar bg="light" expand="lg">
      <Container fluid>
        <Col md="4" className="navbar-wrapper">
          <div className="navbar-minimize">
            <Button
              className="btn-fill btn-round btn-icon d-none d-lg-block bg-dark border-dark"
              variant="dark"
              onClick={() => document.body.classList.toggle("sidebar-mini")}
            >
              <i className="fas fa-bars visible-on-sidebar-regular"></i>
              <i className="fas fa-bars visible-on-sidebar-mini"></i>

            </Button>
            <Button
              className="btn-fill btn-round btn-icon d-block d-lg-none bg-dark border-dark"
              variant="dark"
              onClick={() =>
                document.documentElement.classList.toggle("nav-open")
              }
            >
              <i className="fas fa-list"></i>
              <i className="fas fa-bars visible-on-sidebar-mini"></i>
            </Button>
            {/* <div className="name-navbar">{t("bienvenue")} {nom}</div> */}
          </div>
          <Navbar.Brand
            href="#pablo"
            onClick={(e) => e.preventDefault()}
          ></Navbar.Brand>
        </Col>
        {client && <Col md="8" className="d-flex align-items-center justify-content-end">
          <Col md="2" >
            <Select
              className="react-select primary"
              classNamePrefix="react-select"
              name="singleSelect"
              components={{ DropdownIndicator: customDropdownIndicator }}
              value={annee}
              onChange={(value) => {
                setAnnee(value);
                updateAnnee(value);
              }}
              options={optionsAnnee}
              placeholder="Annee"
            />
          </Col>
          {/* <Col md="1"  >
            <Dropdown as={Nav.Item} className="dropdown-notification">
              <Dropdown.Toggle
                as={Nav.Link}
                id="dropdown-1"
                variant="default"
              >
                <i className="fa-regular fa-bell"></i>
                {nb > 0 ? <span className="notification">{nb}</span> : ""}
              </Dropdown.Toggle>
              <Dropdown.Menu className="noScroll">
                {notification}
              </Dropdown.Menu>
            </Dropdown>
          </Col> */}

          {users.user.id_role == 5 ? <Col md="1"  >
            <Dropdown as={Nav.Item} className="dropdown-notification">
              <Dropdown.Toggle
                as={Nav.Link}
                id="dropdown-1"
                variant="default"
              >
                 <Link to={`/${client}/commandeList`}> <i className="fas fa-hourglass-start"></i>
                  {data > 0 ? <span className="notification">{data}</span> : ""}</Link>
              </Dropdown.Toggle>

            </Dropdown>
          </Col> : null}


          <Col md="2" className="text-center justify-content-end d-inline-flex"  >

            <Col md="6" className="mr-3 here" >
              <div className="form-check form-switch ">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="flexSwitchCheckDefault"
                  checked={isFrench}
                  onChange={() => {
                    setIsFrench(!isFrench);
                    handleLanguageToggle();
                  }}
                />
                <label className="form-check-label" htmlFor="flexSwitchCheckDefault">
                  {isFrench ? "Fr" : "En"}
                </label>
              </div>
            </Col>
            <Dropdown as={Nav.Item} className="dropdown-notification">
              <Dropdown.Toggle
                as={Nav.Link}
                id="dropdown-1"
                variant="default"
              >
                <i className="fa-regular fa-bell"></i>
                {nb > 0 ? <span className="notification">{nb}</span> : ""}
              </Dropdown.Toggle>
              <Dropdown.Menu className="noScroll">
                {notification}
              </Dropdown.Menu>
            </Dropdown>
          </Col>
          <Col md="2"  >
            <Navbar.Collapse id="basic-navbar-nav" className="dropdown-profile">
              <Nav className="ml-auto" navbar>
              </Nav>

            </Navbar.Collapse>
          </Col>



        </Col>}

      </Container>
    </Navbar>
  );
}

export default Header;
